import React from 'react'
import { Provider } from 'mobx-react'
import PaginationSelector from './PaginationSelector'
import { rootStoreInstance } from '../stores'

const StatefulPaginationSelector = () => (
  <Provider store={rootStoreInstance}>
    <PaginationSelector />
  </Provider>
)

export default StatefulPaginationSelector
